import gql from 'graphql-tag'

export const GET_ACHIEVEMENT_LIST_INFO = gql`
  query GetAchievementListInfo($first: Int, $stagesLast: Int, $myAchievementStagesLast: Int, $locale: Locale) {
    achievementCampaigns(first: $first) {
      edges {
        node {
          id
          title(locale: $locale)
          status
          startAt
          iconImageUrl
          completionIconImageUrl
          completionGuide(locale: $locale)
          stages(last: $stagesLast) {
            edges {
              node {
                level
              }
            }
          }
          myAchievementStages(last: $myAchievementStagesLast) {
            edges {
              node {
                stage {
                  guide(locale: $locale)
                  level
                }
                progress {
                  ... on CountQuestProgress {
                    current
                    target
                  }
                  ... on KstDayCountQuestProgress {
                    current
                    target
                  }
                }
                isCompleted
                completedAt
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ACHIEVEMENT_CARD_INFO = gql`
  query GetAchievementCardInfo($first: Int, $stagesLast: Int, $myAchievementStagesLast: Int) {
    achievementCampaigns(first: $first) {
      edges {
        node {
          id
          startAt
          iconImageUrl
          completionIconImageUrl
          stages(last: $stagesLast) {
            edges {
              node {
                level
              }
            }
          }
          myAchievementStages(last: $myAchievementStagesLast) {
            edges {
              node {
                stage {
                  level
                }
                progress {
                  ... on CountQuestProgress {
                    current
                    target
                  }
                  ... on KstDayCountQuestProgress {
                    current
                    target
                  }
                }
                isCompleted
                completedAt
              }
            }
          }
        }
      }
    }
  }
`

export const GET_LEVEL_UP_INFO = gql`
  query GetLevelUpInfo($first: Int, $last: Int) {
    achievementCampaigns(first: $first) {
      edges {
        node {
          myAchievementStages(last: $last) {
            nodes {
              completedAt
            }
          }
        }
      }
    }
  }
`
